// extracted by mini-css-extract-plugin
module.exports = {"TAS":"TAS_TAS__3XonH","cta":"TAS_cta__2xpaK","primaryCta":"TAS_primaryCta__2uDq7","breadcrumbNav":"TAS_breadcrumbNav__4WFA0"};